﻿import React, {ChangeEvent, JSX, useCallback} from "react";
import {useControlId} from "../helpers/useControlId";
import FileInput from "../HtmlControls/FileInput";
import {MvvmPrefixedControlProps} from "./MvvmControlProps";

import {useRegisterValidation} from "./useRegisterValidation";

export type MvvmFilesProps<T extends object> = MvvmPrefixedControlProps<T, FileList | undefined> & {
	multiple?: boolean;
	accept?: string;
	capture?: "user" | "environment" | undefined;
};

export default function MvvmFiles<T extends object = never>(props: MvvmFilesProps<T>): JSX.Element {
	const {
		context,
		property,
		id,
		label,
		hint,
		column,
		controlPrefix,
		controlSuffix,
		hidden,
		disabled,
		validation,
		onChange,
		multiple,
		accept,
		capture
	} = props;

	const controlId = useControlId(id);

	const onChangeInternal = useCallback(function (e: ChangeEvent<HTMLInputElement>): void {
		const value = e.target.files;
		context.setValue(property, value, true);
		if (onChange) onChange(value as FileList);
	}, [context, property, validation, controlId, onChange]);

	useRegisterValidation(context, property, controlId, validation);

	return <FileInput label={label}
	                  name={property}
	                  value={context.getValue<FileList | null>(property)}
	                  controlSuffix={controlSuffix}
	                  controlPrefix={controlPrefix}
	                  hint={hint}
	                  hidden={hidden}
	                  column={column}
	                  id={id}
	                  required={validation?.required != null}
	                  error={context.getError(property)?.error}
	                  disabled={disabled}
	                  onChange={onChangeInternal}
	                  multiple={multiple}
	                  accept={accept}
	                  capture={capture}
	/>;
};
